import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { costBreakdownV2WidgetSetupCostsSelector } from "./costBreakdownV2WidgetSetupCostsSelector";

export const costBreakdownV2WidgetSetupPrevTotalCostSelector =
  createDraftSafeSelector(
    [costBreakdownV2WidgetSetupCostsSelector],
    (costs) => {
      return costs.previousPeriodTotal;
    },
  );
